import "../Style/ToggleArrow.css"
import { ReactComponent as ToggleArrowSvg } from "../SVG/toggle-arrow.svg"

function ToggleArrow(props) {


    return (
        <div className="toggle-arrow">
            {
                (props.isNeed === false) ?
                    <span></span>
                    :
                    <ToggleArrowSvg></ToggleArrowSvg>
                    
                    
            }
        </div>
    );
}

export default ToggleArrow;